import { render, staticRenderFns } from "./benefitsTabs.vue?vue&type=template&id=eee36c04"
import script from "./benefitsTabs.vue?vue&type=script&lang=js"
export * from "./benefitsTabs.vue?vue&type=script&lang=js"
import style0 from "./benefitsTabs.vue?vue&type=style&index=0&id=eee36c04&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports